import axios from 'axios';
import { OpenTicket } from './models';
import { PAY_CREATE_ENDPOINT, OPEN_TICKET_ENDPOINT } from './constants/api';
import * as MutationTypes from './mutationTypes';

export const setSelectedBlock = ({ commit }, payload) => {
  commit(MutationTypes.SET_SELECTED_BLOCK, {
    containerGuid: payload.containerGuid,
    selectedGuid: payload.selectedGuid
  });
};

export const setBrowserItemsOrder = ({ commit }, payload) => {
  commit(MutationTypes.SET_BROWSER_ITEMS_ORDER, {
    containerGuid: payload.containerGuid,
    itemsOrder: payload.itemsOrder
  });
};

export const setClauseGuidWithSectionsGuid = ({ commit }, payload) => {
  commit(MutationTypes.SET_CLAUSE_GUID_WITH_SECTIONS_GUID, payload);
};

export const setSelectedLanguage = ({ commit }, selectedLanguage) => {
  commit(MutationTypes.SET_SELECTED_LANGUAGE, selectedLanguage);
};

export const setScrollBrowserSelected = ({ commit }, payload) => {
  commit(MutationTypes.SET_SCROLL_BROWSER_SELECTION, {
    clauseGuid: payload.clauseGuid,
    sectionGuid: payload.sectionGuid
  });
};

export const setSelectedZoneOfConsume = ({ commit }, selectedZoneOfConsume) => {
  commit(MutationTypes.SET_SELECTED_ZONE_OF_CONSUME, selectedZoneOfConsume);
};

export const setTableGuid = ({ commit }, selectedTableGuid) => {
  commit(MutationTypes.SET_TABLE_GUID, selectedTableGuid);
};

export const setPrices = ({ commit }, prices) => {
  commit(MutationTypes.SET_PRICES, prices);
};

export const setUserDefinedData = ({ commit }, userDefinedData) => {
  commit(MutationTypes.SET_USER_DEFINED_DATA, userDefinedData);
};

const getTicketDetailRequest = (subdomain, saleLocationGuid, invalidate) => axios.get(OPEN_TICKET_ENDPOINT(subdomain, saleLocationGuid, invalidate));

export const getTicketDetail = async ({ commit }, { subdomain, saleLocation, invalidate }) => {
  const response = await getTicketDetailRequest(subdomain, saleLocation, invalidate);
  const ticket = OpenTicket.toInstance(response.data);
  commit(MutationTypes.SET_TICKET_DETAIL_SUCCESS, ticket);
  commit(MutationTypes.SET_SUBDOMAIN_SUCCESS, subdomain);
  commit(MutationTypes.SET_SALE_LOCATION_GUID_SUCCESS, saleLocation);
};

export const setStatus = async ({ commit }, { status }) => {
  commit(MutationTypes.SET_STATUS_SUCCESS, status);
};

export const setCurrencySymbol = ({ commit }, currencySymbol) => {
  commit(MutationTypes.SET_CURRENCY_SYMBOL, currencySymbol);
};

export const setCurrencyPosition = ({ commit }, currencyPosition) => {
  commit(MutationTypes.SET_CURRENCY_POSITION, currencyPosition);
};

export const getPaymentDataRequest = (subdomain, saleLocationGuid, amount, tipAmount) => axios.post(PAY_CREATE_ENDPOINT(subdomain),
  { sale_location__guid: saleLocationGuid, amount, tip_amount: tipAmount });

export const setShowFeatures = ({ commit }, showFeatures) => {
  commit(MutationTypes.SET_SHOW_FEATURES, showFeatures);
};

export const setShowIconFeatures = ({ commit }, showIconFeatures) => {
  commit(MutationTypes.SET_SHOW_ICON_FEATURES, showIconFeatures);
};

export const setShowProductTags = ({ commit }, showProductTags) => {
  commit(MutationTypes.SET_SHOW_PRODUCT_TAGS, showProductTags);
};

export const setShowIconProductTags = ({ commit }, showIconProductTags) => {
  commit(MutationTypes.SET_SHOW_ICON_PRODUCT_TAGS, showIconProductTags);
};

export const addShopList = ({ commit }, shopItem) => {
  commit(MutationTypes.ADD_SHOP_LIST, shopItem);
};

export const subtractShopList = ({ commit }, productGuid) => {
  commit(MutationTypes.SUBTRACT_SHOP_LIST, productGuid);
};

export const setSubdomain = ({ commit }, subdomain) => {
  commit(MutationTypes.SET_SUBDOMAIN_SUCCESS, subdomain);
};

export const resetShopList = ({ commit }) => {
  commit(MutationTypes.RESET_SHOP_LIST);
};
